import { instrumentationSchema } from './instrumentation-schema';

export class AuctionInsightLogService {
  constructor(props) {
    const {
      instrumentation,
    } = props;
    instrumentation.addScenario(instrumentationSchema);
    const fluctuationScenario = instrumentation.auctionInsight.create();
    this.activities = {
      userActionActivity: fluctuationScenario.userAction.create(),
      feedbackActivity: fluctuationScenario.auctionInsightFeedback.create(),
    };
  }

  composeLogObj({
    eventType, insightData, context, note,
  }) {
    return {
      eventType,
      insightData,
      userId: context.CurrentUser.Id,
      customerId: context.CurrentCustomer.Id,
      isInternal: context.CurrentUser.IsInternal,
      note,
    };
  }

  logFeedback({ insightData, context, note }) {
    const logObject = this.composeLogObj({
      insightData,
      eventType: 'feedback',
      context,
      note,
    });
    this.activities.feedbackActivity.trace(`AuctionInsightLog: ${JSON.stringify(logObject)}`, 'AuctionInsightFeedback');
  }

  logAction({ insightData, context, note }) {
    const logObject = this.composeLogObj({
      insightData,
      eventType: 'userAction',
      context,
      note,
    });
    this.activities.userActionActivity.trace(`AuctionInsightLog: ${JSON.stringify(logObject)}`, 'AuctionInsightAction');
  }
}
